import { useEffect, useRef } from "react";
import { PaperGradientBG } from "../kits";
import { scrollHeaderIntoView } from "./utils/scrollToHeader";

export default function ServiceSection({ onToggle, isOpen = false, headerRef }) {
  const localHeaderRef = useRef(null);
  const resolvedHeaderRef = headerRef || localHeaderRef;

  useEffect(() => {
    if (!isOpen || !resolvedHeaderRef.current) return;
    scrollHeaderIntoView(resolvedHeaderRef.current, "smooth", 8);
  }, [isOpen, resolvedHeaderRef]);

  return (
    <PaperGradientBG variant="zenBlack">
      <section className="py-16 sm:py-20">
        <div
          ref={resolvedHeaderRef}
          className="group max-w-4xl mx-auto px-6 text-center font-mono cursor-pointer select-none"
          style={{ scrollMarginTop: "calc(var(--navbar-height, 0px) + 12px)" }}
          role="button"
          tabIndex={0}
          aria-expanded={isOpen}
          onClick={onToggle}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") onToggle?.();
          }}
        >
          <p className="text-xs text-[#EFEBDC]/50 mb-3">
            <span className="text-[#AC8E66]">$</span> ls services/
          </p>

          <h2 className="text-2xl sm:text-3xl font-bold text-[#EFEBDC] mb-2 transition-colors duration-200 group-hover:text-[#AC8E66]">
            <span
              className={`inline-block text-brand/80 transition-transform duration-200 group-hover:scale-110 group-hover:text-[#AC8E66] ${
                isOpen ? "rotate-90" : "rotate-0"
              }`}
              aria-hidden="true"
            >
              &gt;
            </span>{" "}
            Software, Training, Beratung
          </h2>

          <p className="text-sm text-[#AC8E66] mt-3">
            Services {isOpen ? "$ status ... ready" : "$ status ... standby"}
          </p>
          <div className="mt-4 flex justify-center gap-6 sm:gap-10 border-t border-[#AC8E66]/10 pt-4">
            {[
              { value: "250+", label: "trainings" },
              { value: "50+", label: "projekte" },
              { value: "10+", label: "jahre" },
            ].map((metric) => (
              <div key={metric.label} className="text-center">
                <span className="block text-sm font-bold text-[#AC8E66]">{metric.value}</span>
                <span className="text-[10px] uppercase tracking-[0.18em] text-[#EFEBDC]/40">{metric.label}</span>
              </div>
            ))}
          </div>
          <p className="text-xs text-[#EFEBDC]/50 mt-4">
            Die funktioniert. Und verstanden wird.
          </p>
        </div>
      </section>
    </PaperGradientBG>
  );
}
